import {  fetchAiImages } from './effects';
import { $aiImages } from './states';

// AI Images
$aiImages.on(fetchAiImages.doneData, (_, data) => data);